import Statusbar from '../../Statusbar';
import soundExecutor from './soundExecutor';

const millisecondsInSecond = 1000;

function getGiphyIdFromURL(url) {
	if (!url) return null;

	// If it's already just an ID (alphanumeric string), return it
	if (/^[a-zA-Z0-9]+$/.test(url.trim())) {
		return url.trim();
	}

	// Clean up the URL
	url = url.trim().replace(/\/+$/, '');

	// Extract ID from Giphy URL
	const parts = url.split('-');
	const gifId = parts[parts.length - 1];
	
	if (/^[a-zA-Z0-9]+$/.test(gifId)) {
		return gifId;
	}

	return null;
}

export default function giphyExecutor({
	videoId, 
	text = '',
	duration = 10,
	spin,
	sound,
	playCount,
}, done, { endEvent }) {
	log(`Notifications.doGiphy "${videoId}" with text "${text}"`);

	Statusbar.addStatus({ title: text });

	if (text || videoId) {
		const giphyId = getGiphyIdFromURL(videoId);
		
		if (!giphyId) {
			log('Invalid Giphy URL or ID provided');
			Screen.logMessageToSentry('Giphy notification failed - invalid URL/ID');
			done();
			return;
		}

		return playGiphy({
			giphyId,
			text,
			duration,
			spin,
			sound,
			playCount
		}, done);
	} else {
		done();
	}
}

function playGiphy({
	giphyId,
	text,
	duration,
	spin,
	sound,
	playCount
}, done) {
	// Create the Giphy embed URL
	let embedUrl = `https://giphy.com/embed/${giphyId}`;
	
	// Add spin parameter if provided
	if (spin) {
		embedUrl += `?spin=${spin}`;
	}

	// Create the iframe element
	const iframe = $('<iframe class="notification-giphy-iframe" />');
	iframe.attr({
		src: embedUrl,
		width: '100%',
		height: '100%',
		frameBorder: '0',
		allow: 'autoplay; clipboard-write; encrypted-media; picture-in-picture',
		allowFullScreen: true
	});
	iframe.css('pointer-events', 'none');

	const notification = createNotificationDOMNode(iframe, text);
	Screen.elements.notifications.append(notification);

	// Start sound if provided
	if (sound) {
		soundExecutor({
			sound: sound,
			playCount: playCount,
		}, () => {});
	}

	const onEnd = () => {
		log('Giphy notification closing');
		notification.remove();
		done();
	};

	const onForceEnd = () => {
		log('Giphy notification closed forcefully');
		onEnd();
	};

	// Show the notification immediately since Giphy doesn't need loading
	notification.removeClass('displaynone');
	log('Giphy notification playing...');

	// Set up the duration timer
	const durationTimeout = setTimeout(onEnd, duration * millisecondsInSecond);

	// Return the force end function so it can be called if needed
	const forceEndFunction = () => {
		clearTimeout(durationTimeout);
		onForceEnd();
	};

	return forceEndFunction;
}

function createNotificationDOMNode(iframe, text) {
	const textDiv = $('<div class="notification-youtube-text"></div>');
	textDiv.text(text);
	
	const el = $('<div class="notification-youtube" />');
	el.append(iframe);
	el.append(textDiv);
	
	const notification = $('<div class="notification" />');
	notification.append($('<div class="overlay"></div>'));
	notification.append(el);
	notification.addClass('displaynone');
	
	return notification;
}
